import { useSubmitEmailMutation } from '@twisto/api-graphql'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import { useForm } from '@twisto/components/atoms/form'
import { useResponseErrors } from '@twisto/form'

import { FlowForm } from '../../components'
import { useFlow } from '../../flow/flow.context'
import { AccountExistsModal } from '../account-exists-modal'

import { EmailPrivacyPolicyStepFormContent } from './email-privacy-policy-step-form-content'
import { EmailPrivacyPolicyStepHeadline } from './email-privacy-policy-step-headline'

const fieldNames = {
  email: 'email',
} as const

type FormValues = {
  [fieldNames.email]: string
}

export const EmailPrivacyPolicyStep = () => {
  const { flow, sessionId } = useFlow<
    'EmailPrivacyPolicyStep' | 'AccountExistsStep'
  >()
  const [submitEmail, { data }] = useSubmitEmailMutation()

  const { email, __typename: stepName } = flow.currentStep

  const formContext = useForm({
    defaultValues: {
      [fieldNames.email]: email.value ?? '',
    },
  })

  // handle field errors - such a invalid email
  useResponseErrors(data?.submitEmail, formContext)

  const handleSubmit: CastedSubmitHandler<FormValues> = ({
    email,
  }: FormValues) => submitEmail({ variables: { email, auth: { sessionId } } })

  return (
    <>
      <EmailPrivacyPolicyStepHeadline />
      <FlowForm {...formContext} onSubmit={handleSubmit}>
        <EmailPrivacyPolicyStepFormContent currentStep={flow.currentStep} />
      </FlowForm>
      {stepName === 'AccountExistsStep' && <AccountExistsModal />}
    </>
  )
}
